import classNames from 'classnames';
import { memo } from 'react';

import styles from './index.less';

interface IProps {
  width?: string;
  height?: string;
  className?: string;
  color?: string;
}

function SvgLoading(props: IProps): JSX.Element {
  const { height, width, className, color } = props;

  return (
    <div className={classNames(className, styles.loading)}>
      <svg
        fill={color}
        height={height || '16px'}
        viewBox="0 0 1024 1024"
        width={width || '16px'}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M512,942A429.54,429.54,0,0,1,82,512a30.24,30.24,0,0,1,60.47,0,369.53,369.53,0,1,0,739.06,0A369.09,369.09,0,0,0,512,142.47,30.24,30.24,0,0,1,512,82,430.09,430.09,0,0,1,679.38,908.15,425.82,425.82,0,0,1,512,942Z"
          fillOpacity="0.85"
        />
      </svg>
    </div>
  );
}

export default memo(SvgLoading);
